import { forwardRef } from 'react';
import { NavLink, NavLinkProps } from 'react-router';

export const RouterLink = forwardRef<HTMLAnchorElement, NavLinkProps>(function Link(
  itemProps,
  ref
) {
  return <NavLink ref={ref} {...itemProps} role={undefined} />;
});
